import React, { Component } from 'react';
import { Button, Select } from 'antd';
import './index.css'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../core/reducers';
import { 
    actionLoginEntryMerchant,
    actionLoginSilizhuEntryMerchant,
    actionSendCaptcha,
    actionRegister,
    actionResetPassword,
    actionSureOrg,
    actionLoginEntryInsFail,
    actionRegisterFail,
 } from '../../../core/actions/user';
import PasswordForm from './form/passwordForm'
import CaptchaForm from './form/captchaForm'
import RegisterForm from './form/registerForm'
import ResetPasswordForm from './form/resetPassword'
import { RouteComponentProps } from 'react-router-dom';
import img_login from './img_login.png'
import { LoginDevice } from '../../../javascripts/public';

interface StateProps {
    orgList: any[]
    isResetPassword: boolean
    menuData: any[]
    loginStatus: boolean,
    isSure: boolean,
    loginFailData: string
    registerFailData: string
}

interface DispatchProps {
    login(data, isCaptcha) : void
    loginSilizhu(data, isCaptcha): void
    sendCaptcha(data, isRegister): void
    register(data, isIns): void
    resetPassword(data): void
    sureOrg(data): void
    clearError(login, register, resetPassword): void
}

const { Option } = Select;

type PropsType = StateProps & RouteComponentProps
class Index extends Component<PropsType & DispatchProps> {
    
    state = {
        isPassword: true,
        status: 'login',
        org: {
            name: ''
        },
    }

    changeIsPassword = (value) => {
        this.setState({
            isPassword: value
        })
        this.clearErrorData();
    }

    componentDidMount () {
        localStorage.removeItem('loginStatus');
        localStorage.removeItem('accessToken');
    }

    static getDerivedStateFromProps (props, state) {
        if(props.loginStatus && props.orgList.length ) {
            return {
                status: 'select',
            }       
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        const { history, loginStatus, menuData, isSure } = this.props;
        console.log(loginStatus, menuData.length, isSure)
        if(loginStatus && menuData.length && isSure) {
            history.push(menuData[0].path);
        }

    }

    login = (data, isCaptcha) => {
        console.log(data);
        if(data.device === LoginDevice.SCANNER) {
            this.props.login(data, isCaptcha)
        }
        else if(data.device === LoginDevice.SILIZHU) {
            this.props.loginSilizhu(data, isCaptcha)
        }
    }

    returnIndexCom  = () => {
        let isPassword = this.state.isPassword;
        return (
            <div className="content-form">
                 <ul>
                    <li 
                        className={isPassword ? "clicked" : ''}
                        onClick={() => this.changeIsPassword(true)}
                    >密码登录</li>
                    <li 
                        className={!isPassword ? "clicked" : ''}
                        onClick={() => this.changeIsPassword(false)}
                    >快捷登录</li>
                </ul>
                <div>
                    {
                        isPassword ? 
                        <PasswordForm 
                            loginFailData={this.props.loginFailData}
                            login={this.login} 
                            forget={this.forget}
                            /> : 
                        <CaptchaForm
                            loginFailData={this.props.loginFailData}
                            login={this.login} 
                            sendCaptcha={this.props.sendCaptcha}
                            forget={this.forget}
                            />
                    }
                </div>
                <p> 
                    没有账号? 
                    {/* <a onClick={() => this.changeStatus('register')}>立即注册</a> */}
                    <a onClick={() => this.goRegister()}>立即注册</a>
                </p>
            </div>
        )
    }

    returnSelectCom = () => {
        let orgList = this.props.orgList || [];
        let org = this.state.org;
        if(orgList.length === 1) {
            let org = orgList[0];
            this.props.sureOrg(org);
        }
        return (
            <div className="content-form">
                <div className="select-more">
                    <Select
                        placeholder="请选择商户端"
                        className="select" 
                        value={org.name ? org.name : "请选择商户端"}
                        onChange={this.changeName}
                        >
                        {
                            orgList.map((item) => {
                                return (
                                    <Option 
                                        key={item.id} 
                                        value={item.id}
                                        >
                                        {item.name}
                                    </Option>
                                )
                            })
                        }
                    </Select>
                    <Button 
                        type="primary" 
                        size="large" 
                        className="btn_sure"
                        onClick={() => this.sureOrg()}
                        >确认</Button>
                </div>
            </div>
        )
    }

    returnRegisterCom = () => {
        return (
            <div className="content-form">
                <div className="register">
                    <p className="register-title">账号注册</p>
                    <RegisterForm 
                        registerFailData={this.props.registerFailData}
                        sendCaptcha={this.props.sendCaptcha}
                        register={this.props.register}
                        />
                    <p className="text-center">
                        已有账号? 
                        <a onClick={() => this.changeStatus('login')}>立即登录</a>
                    </p>
                </div>
            </div>
        )
    }

    returnResetCom = () => {
        return (
            <div className="content-form-reset">
                <p className="reset-title">重置密码</p>
                <ResetPasswordForm 
                    sendCaptcha={this.props.sendCaptcha} 
                    resetPassword={this.props.resetPassword} 
                    />
                <p className="text-center">
                    记起密码? 
                    <a onClick={() => this.changeStatus('login')}>返回登录</a>
                </p>
            </div>
        )
    }

    returnComp = () => {
        let isResetPassword = this.props.isResetPassword;
        let status = this.state.status;
        if(isResetPassword && status === 'reset') {
            return this.returnIndexCom();
        }
        switch(status) {
            case 'register': return this.returnRegisterCom();
            case 'reset': return this.returnResetCom();
            case 'select': return this.returnSelectCom();
            default: return this.returnIndexCom();
        }
    }

    changeStatus = (value) => {
        this.setState({
            status: value
        })
        this.clearErrorData();
    }

    clearErrorData = () => {
        let loginFailData = this.props.loginFailData;
        let registerFailData = this.props.registerFailData;
        this.props.clearError(loginFailData, registerFailData, false)
    }

    forget = () => {
        this.setState({
            status: 'reset'
        })
    }

    changeName = (value) => {
        console.log(`selected ${value}`);
        let orglist = this.props.orgList;
        let org = orglist.find((item) => {
            return item.id == value
        }) || {};
        this.setState({
            org: org,
        })
    }

    sureOrg = () => {
        let org = this.state.org;
        this.props.sureOrg(org);
    }

    goRegister = () => {
        this.clearErrorData();
        const { history } = this.props;
        history.push('/merchant/register');
    }

    render () {

        let status = this.state.status;
        let component = this.returnComp();

        return (
            <div className="mer_login">
                <div className="header">
                    <h3>SennoFeet</h3>
                    <div>
                        <Button 
                            className="margin-right-20" 
                            onClick={() => this.changeStatus('login')}
                            >登录</Button>
                        <Button 
                            type="primary" 
                            className="btn-blue"
                            onClick={() => this.goRegister()}
                            // onClick={() => this.changeStatus('register')}
                            >注册</Button>
                    </div>
                </div>
                {
                    status === 'reset' ?
                    <div className="content">
                        {component}
                    </div>
                    :
                    <div className="content">
                        <div className="content-left">
                            <h1>足压足型测评系统管理后台-商户端</h1>
                            <img src={img_login} className="img-login"/>
                        </div>
                        {component}
                    </div>
                }
                <div className="foot">
                    <p>Copyright © SennoFeet足压后台  2020-2050</p>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        loginStatus: state.user.loginStatus,
        menuData: state.user.menuData,
        isResetPassword: state.user.isResetPassword,
        orgList: state.user.orgList,
        isSure: state.user.isSure,
        loginFailData: state.user.loginInsFailData,
        registerFailData: state.user.registerFailData
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        login: (data, isCaptcha) => {
            dispatch(actionLoginEntryMerchant(data, isCaptcha))
        },
        loginSilizhu: (data, isCaptcha) => {
            dispatch(actionLoginSilizhuEntryMerchant(data, isCaptcha))
        },
        sendCaptcha: (data, isRegister) => {
            dispatch(actionSendCaptcha(data, isRegister))
        },
        register: (data, isIns) => {
            dispatch(actionRegister(data, true))
        },
        resetPassword: (data) => {
            dispatch(actionResetPassword(data))
        },
        sureOrg: (data) => {
            dispatch(actionSureOrg(data))
        },
        clearError: (login, register, resetPassword) => {
            if(login) {
                dispatch(actionLoginEntryInsFail({
                    data: ''
                }));
            }
           if(register) {
                dispatch(actionRegisterFail({
                    data: ''
                }))
           }
        }
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index as any)